import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=bd3fbe30&"
import script from "./Clusters.vue?vue&type=script&lang=js&"
export * from "./Clusters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports